/* eslint arrow-body-style: 0 */
import ContactsView from './components/ContactsView';
import ContactManageView from './pages/ContactManageView';
import HomeByPhone from './components/HomeByPhone';
import { frontendURL } from '../../../helper/URLHelper';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/contacts'),
    name: 'contacts_dashboard',
    roles: ['administrator', 'agent', 'supervisor', 'team_supervisor', 'seller', 'analyzer', 'assistant'],
    component: ContactsView,
  },
  {
    path: frontendURL('accounts/:accountId/contacts/custom_view/:id'),
    name: 'contacts_segments_dashboard',
    roles: ['administrator', 'agent', 'supervisor', 'team_supervisor', 'seller', 'analyzer', 'assistant'],
    component: ContactsView,
    props: route => {
      return { segmentsId: route.params.id };
    },
  },
  {
    path: frontendURL('accounts/:accountId/labels/:label/contacts'),
    name: 'contacts_labels_dashboard',
    roles: ['administrator', 'agent', 'supervisor', 'team_supervisor', 'seller', 'analyzer', 'assistant'],
    component: ContactsView,
    props: route => {
      return { label: route.params.label };
    },
  },
  {
    path: frontendURL('accounts/:accountId/contacts/:contactId'),
    name: 'contact_profile_dashboard',
    roles: ['administrator', 'agent', 'supervisor', 'team_supervisor', 'seller', 'analyzer', 'assistant'],
    component: ContactManageView,
    props: route => {
      return { contactId: route.params.contactId };
    },
  },
  {
    path: frontendURL('accounts/:accountId/home-by-contact/:phone'),
    name: 'contact_embedding_dashboard',
    roles: ['administrator', 'agent', 'supervisor', 'team_supervisor', 'seller', 'analyzer', 'assistant'],
    component: HomeByPhone,
     props: route => {
      return { phone: route.params.phone, name: route.query.name };
    },
  },
];
